import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FEATURED_NEW_ARRIVALS_CATEGORY_URL_ID } from "@faire/retailer-shared/categories/urlId";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { CategoryPagePaths } from "@faire/retailer-visitor-shared/paths/CategoryPage";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { THREE_TO_TWO_LETTER_LANGUAGE_CODE } from "@faire/web--source/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { convertLocaleToCountryLocaleString } from "@faire/web--source/common/localization/languageWithCountryOptions";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { PageLoader } from "@faire/web--source/ui/CircleSpinner";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import * as React from "react";
import styled from "styled-components";
import { SITEMAP_LANGUAGE_LABELS, SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS } from "./consts";
export var SiteMap = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useCategoryStore = useCategoryStore(), categoriesLoading = _useCategoryStore.categoriesLoading, categories = _useCategoryStore.categories;
    var routingContext = useRetailerRoutingContext();
    var _getGlobalProperty;
    var availableLanguageSelectorLocales = (_getGlobalProperty = getGlobalProperty("availableLanguageSelectorLocales")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : [];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            categoriesLoading ? /*#__PURE__*/ _jsx(PageLoader, {}) : null,
            /*#__PURE__*/ _jsxs(Wrapper, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            tabletAndAbove: "5x"
                        }
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        as: "h1",
                        variant: {
                            mobileAndAbove: "displayMSerifRegular",
                            tabletAndAbove: "displayLSerifRegular"
                        },
                        align: "center",
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "M/I60V",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Faire Site Map"
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            tabletAndAbove: "5x"
                        }
                    }),
                    /*#__PURE__*/ _jsxs(List, {
                        children: [
                            categories === null || categories === void 0 ? void 0 : categories.filter(function(category) {
                                return !!category.path_identifier && category.url_id !== FEATURED_NEW_ARRIVALS_CATEGORY_URL_ID;
                            }).map(function(category) {
                                var _category_sub_categories;
                                var _category_url_id;
                                return /*#__PURE__*/ _jsxs(SubList, {
                                    children: [
                                        /*#__PURE__*/ _jsx(ListItem, {
                                            variant: "paragraphSansMedium",
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                title: category.name,
                                                to: CategoryPagePaths.index({
                                                    categoryUrlIds: [
                                                        {
                                                            id: (_category_url_id = category.url_id) !== null && _category_url_id !== void 0 ? _category_url_id : ""
                                                        }
                                                    ],
                                                    routingContext: routingContext
                                                }),
                                                children: category.name
                                            })
                                        }),
                                        (_category_sub_categories = category.sub_categories) === null || _category_sub_categories === void 0 ? void 0 : _category_sub_categories.map(function(subCategory) {
                                            var _category_url_id, _subCategory_url_id;
                                            return /*#__PURE__*/ _jsx(ListItem, {
                                                children: /*#__PURE__*/ _jsx(Link, {
                                                    title: subCategory.name,
                                                    to: CategoryPagePaths.index({
                                                        categoryUrlIds: [
                                                            {
                                                                id: (_category_url_id = category.url_id) !== null && _category_url_id !== void 0 ? _category_url_id : ""
                                                            },
                                                            {
                                                                id: (_subCategory_url_id = subCategory.url_id) !== null && _subCategory_url_id !== void 0 ? _subCategory_url_id : ""
                                                            }
                                                        ],
                                                        routingContext: routingContext
                                                    }),
                                                    children: subCategory.name
                                                })
                                            }, subCategory.path_identifier);
                                        })
                                    ]
                                }, category.path_identifier);
                            }),
                            /*#__PURE__*/ _jsxs(SubList, {
                                "data-test-id": "siteMapLanguages",
                                children: [
                                    /*#__PURE__*/ _jsx(ListItem, {
                                        variant: "paragraphSansMedium",
                                        children: /*#__PURE__*/ _jsx(Link, {
                                            title: "About Faire",
                                            to: "#",
                                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "s90A1P",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "About Faire"
                                                    }
                                                ]
                                            })
                                        })
                                    }),
                                    Object.keys(THREE_TO_TWO_LETTER_LANGUAGE_CODE).filter(function(language) {
                                        return(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                        !!SITEMAP_LANGUAGE_LABELS(strictLocalize)[language]);
                                    }).map(function(language) {
                                        return /*#__PURE__*/ _jsx(ListItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                title: // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                                SITEMAP_LANGUAGE_LABELS(strictLocalize)[language],
                                                to: "/".concat(// @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                                THREE_TO_TWO_LETTER_LANGUAGE_CODE[language].toLowerCase(), "/"),
                                                children: // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                                SITEMAP_LANGUAGE_LABELS(strictLocalize)[language]
                                            })
                                        }, language);
                                    }),
                                    availableLanguageSelectorLocales.map(function(locale) {
                                        var // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                        _SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS_country;
                                        var language = locale.language, country = locale.country;
                                        if (country && language && ((_SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS_country = SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS(strictLocalize)[country]) === null || _SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS_country === void 0 ? void 0 : _SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS_country[language])) {
                                            var label = // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                                            SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS(strictLocalize)[country][language];
                                            var convertedLocale = convertLocaleToCountryLocaleString(locale);
                                            if (convertedLocale) {
                                                return /*#__PURE__*/ _jsx(ListItem, {
                                                    children: /*#__PURE__*/ _jsx(Link, {
                                                        title: label,
                                                        to: "".concat(convertedLocale, "/"),
                                                        children: label
                                                    })
                                                }, country);
                                            }
                                        }
                                        return null;
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "3x",
                            tabletAndAbove: "5x"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Footer, {})
        ]
    });
};
var Wrapper = styled.section.withConfig({
    componentId: "sc-1c9cf2c6-0"
})([
    "width:100%;max-width:800px;margin:0 auto;",
    "{padding:",
    ";}"
], responsiveMediaQueries.mobile, getSpacing(0, "3x"));
var List = styled.section.withConfig({
    componentId: "sc-1c9cf2c6-1"
})([
    "column-count:3;"
]);
var SubList = styled.section.withConfig({
    componentId: "sc-1c9cf2c6-2"
})([
    "margin-bottom:",
    ";break-inside:avoid-column;"
], getSpacing("3x"));
var ListItem = styled(Typography).withConfig({
    componentId: "sc-1c9cf2c6-3"
})([
    "line-height:30px;"
]);
